const NS = 'bikesbooking';

export const subscribe = (handlers, namespace = NS) => {
  let invoker = ({ data }) => {
    try {
      const message = JSON.parse(data);
      if (!message || !message.type) {
        return;
      }

      const [prefix, ...types] = message.type.split('.');

      if (prefix !== namespace) {
        return;
      }

      const handler = handlers[types.join('.')];

      if (!handler) {
        return;
      }

      // finally we got to handler
      handler(message);
    } catch (ignored) {}
  };

  window.addEventListener('message', invoker, false);

  return () => {
    window.removeEventListener('message', invoker, false);
    invoker = null;
  };
};

export const publish = (event, data, target) => target.postMessage(JSON.stringify({
  type: `${NS}.${event}`,
  data
}), '*');



// WEBPACK FOOTER //
// ./src/partners/embed/utils/messaging.js